export const STOCK_TREE_SET = 'STOCK_TREE_SET'
export const STOCK_TREE_FETCHING = 'STOCK_TREE_FETCHING'
export const STOCK_TREE_ADD = 'STOCK_TREE_ADD'
export const STOCK_TREE_ADDING = 'STOCK_TREE_ADDING'
export const STOCK_TREE_UPDATE = 'STOCK_TREE_UPDATE'
export const STOCK_TREE_UPDATING = 'STOCK_TREE_UPDATING'
export const STOCK_TREE_SELECTED_SET = 'STOCK_TREE_SELECTED_SET'
export const STOCK_TREE_SELECTED_FETCHING = 'STOCK_TREE_SELECTED_FETCHING'
export const STOCK_TREE_SELECTED_UPDATING = 'STOCK_TREE_SELECTED_UPDATING'
